import styled from "styled-components"

interface AdminElementBanner {
  bgImagen?: string
}

export const AdminElementBanner = styled.div`
  background-image: url(${(p: AdminElementBanner) =>
    p.bgImagen ? p.bgImagen : ""});
  background-position: center top;
  background-repeat: no-repeat;
  background-attachment: local;
  background-size: cover;
  width: 100%;
  height: 100px;
  position: relative;
  padding: 2rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`

interface AdminElementBannerTitle {
  textColor?: string
}

export const AdminElementBannerTitle = styled.h1`
  font-size: 4.1rem;
  color: ${(p: AdminElementBannerTitle) => p.textColor ? p.textColor : "var(--color-text)"};
  @media (max-width: 780px) {
    font-size: 2.1rem;
  }
`

interface AdminElementContainer {
  bg?: string
}

export const AdminElementContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 1rem;
  background-color: ${(p: AdminElementContainer) =>
    p.bg ? p.bg : "var(--color-menu-bg)"};
  justify-items: center;
  margin-bottom: 35px;
  padding: 20px;
  padding-top: 30px;
    
  @media (max-width: 780px) {
    grid-template-columns: repeat(1, 1fr);
  }
`
